import { useEffect, useState } from "react";
import styles from "./style.module.css";
function Dropdown(Props) {
  const { option, id, setNewValue, newValue, ...rest } = Props;
  const [actived, setActived] = useState(false);
  const handleGetValue = (item) => {
    console.log(item);
    if (!item.disabled) {
      setNewValue(item.value);
    }
  };
  function truncateText(text, maxLength) {
    if (text.length <= maxLength) {
      return text;
    } else {
      const end = text.slice(-maxLength / 2);
      return text.slice(0, maxLength) + "..." + end;
    }
  }
  useEffect(() => {
    setActived(false);
  }, [newValue]);

  return (
    <div className={styles.dropdownBox}>
      <div className={styles.title} onClick={() => setActived((prev) => !prev)}>
        <span>
          {newValue && newValue.length > 60
            ? truncateText(newValue, 10)
            : newValue && newValue.length < 60  
            ? newValue
            : "chọn..."}
        </span>
        <svg
          width="22"
          height="23"
          style={{
            transform: `rotate(${actived ? "180deg" : "0deg"})`,
            transition: "transform ease-in-out 300ms",
          }}
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.3452 9.1697C17.1578 8.98345 16.9044 8.87891 16.6402 8.87891C16.376 8.87891 16.1225 8.98345 15.9352 9.1697L12.3452 12.7097L8.80517 9.1697C8.71193 9.07712 8.60137 9.00381 8.4798 8.95395C8.35823 8.9041 8.22803 8.87868 8.09664 8.87914C7.96524 8.87961 7.83522 8.90595 7.71401 8.95666C7.59279 9.00737 7.48275 9.08146 7.39017 9.1747C7.29759 9.26794 7.22428 9.3785 7.17443 9.50007C7.12457 9.62164 7.09915 9.75184 7.09962 9.88323C7.10008 10.0146 7.12642 10.1446 7.17713 10.2659C7.22784 10.3871 7.30193 10.4971 7.39517 10.5897L11.6352 14.8297C11.7281 14.9235 11.8386 14.998 11.9605 15.0489C12.0824 15.0997 12.2131 15.1259 12.3452 15.1259C12.4772 15.1259 12.608 15.0997 12.7298 15.0489C12.8517 14.998 12.9623 14.9235 13.0552 14.8297L17.3452 10.5897C17.4389 10.4967 17.5133 10.3861 17.5641 10.2643C17.6148 10.1424 17.641 10.0117 17.641 9.8797C17.641 9.74769 17.6148 9.61698 17.5641 9.49512C17.5133 9.37326 17.4389 9.26266 17.3452 9.1697Z"
            fill="#344767"
          />
        </svg>
      </div>
      <div
        className={`${styles.box} ${actived ? styles.active : ""}`}
        onMouseLeave={() => setActived(false)}
      >
        {option.map((item, i) => (
          <div className={styles.item} key={i} onClick={() => handleGetValue(item)}>
            {item?.label}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Dropdown;
